/** @file dilateMask: a 0/1 mask grown by r pixels in every direction (a square, chessboard distance). */

/** A running 1-D max of radius `r` over the `len` cells at `start + k * step`, from `src` into `dst`. */
function maxLine(src: Uint8Array, dst: Uint8Array, start: number, step: number, len: number, r: number): void {
  let last = -Infinity;
  for (let k = 0; k < len + r; k++) {
    if (k < len && src[start + k * step] === 1) last = k;
    const out = k - r;
    if (out >= 0 && last >= out - r) dst[start + out * step] = 1;
  }
}

/** `mask` (`width * height`, 0 or 1) where every 1 also sets its (2r+1) x (2r+1) neighbourhood; r <= 0 returns a copy. */
export function dilateMask(mask: Uint8Array, width: number, height: number, r: number): Uint8Array {
  if (r <= 0) return mask.slice();
  const rows = new Uint8Array(mask.length);
  for (let y = 0; y < height; y++) maxLine(mask, rows, y * width, 1, width, r);
  const out = new Uint8Array(mask.length);
  for (let x = 0; x < width; x++) maxLine(rows, out, x, width, height, r);
  return out;
}
